import { TranslateService } from "@ngx-translate/core";

export abstract class FuncionarioTranslate {
  /**
   *
   */
  constructor(translate: TranslateService) {
    this.ERRO = translate.instant('ERRO');
    this.FEITO = translate.instant('FEITO');
    this.FUNCIONARIO_ALTERADO = translate.instant('FUNCIONARIO_ALTERADO');
    this.FUNCIONARIO_CADASTRADO = translate.instant('FUNCIONARIO_CADASTRADO');
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.CANCELAR = translate.instant('CANCELAR');
    this.SIM = translate.instant('SIM');
    this.FUNCIONARIO_DELETADO = translate.instant('FUNCIONARIO_DELETADO');
  }
  ERRO: string = 'Erro!';
  FEITO: string = 'Feito!';
  FUNCIONARIO_ALTERADO: string = 'Funcionário alterado!';
  FUNCIONARIO_CADASTRADO: string = 'Funcionário cadastrado!';
  SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string = 'Se deletar, esta ação não poderá ser desfeita!';
  CANCELAR: string = 'Cancelar';
  SIM: string = 'Sim';
  FUNCIONARIO_DELETADO: string = 'Funcionário deletado!';
  DELETAR_PARAM: string;

}
